// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyState_wrapper__D5uwb","content":"EmptyState_content__33SN7","mainMessage":"EmptyState_mainMessage__Wb6hM"};